import api from "../api/client";

const freightApi2 = {
  create(payload, releaseFreight = false) {
    return api.post(
      `/freight/save?isReleaseFreight=${releaseFreight}`,
      payload,
    );
  },

  update(
    id,
    payload,
    isFinalize = false,
    releaseFreight = false,
    isReopenFreight = false,
  ) {
    return api.patch(
      `/freight/update/${id}?isFinalize=${isFinalize}&isReleaseFreight=${releaseFreight}&isReopenFreight=${isReopenFreight}`,
      payload,
    );
  },

  cancel(id, reason,payload) {
    return api.patch(`/freight/v1/cancel/${id}`, {
      ...payload,
      reason,
    });
  },

  reactivate(id, idUser) {
    return api.patch(`/freight/v1/reactivate/${id}`, { idUser });
  },

  getById(id, params = {}) {
    return api.get(`/freight/getFreightByIdWithStoppingPoints/${id}`, {
      params,
    });
  },

  getAllFreights(params) {
    return api.get("/freight", { params });
  },

  /*Lista paginada (cursor) com filtros no servidor — GET /freight/v2 */
  getAllFreightsV2(params) {
    return api.get("/freight/v2", { params });
  },

  /* Lista de faturas (painel financeiro) — GET /freight/invoices */
  getInvoices(params) {
    return api.get("/freight/invoices", { params });
  },

  delete(id) {
    return api.delete(`/freight/delete/${id}`);
  },

  queue(id) {
    return api.get(`/freight/${id}/queue`);
  },

  transportQueue(id, isShipper) {
    return api.get(`/freight/${id}/transport-queue`, {
      params: { isShipper },
    });
  },

  getAvailableFreights(params) {
    return api.get("/freight/available", { params });
  },

  getAvailableFreightById(id, idCarrier, idUser) {
    const params = {};
    if (idCarrier) params.idCarrier = idCarrier;
    if (idUser) params.idUser = idUser;
    return api.get(`/freight/available/${id}`, {
      params: Object.keys(params).length ? params : undefined,
    });
  },

  submitBid(id, payload = {}) {
    return api.post(`/freight/available/${id}/bid`, payload);
  },

  acceptFreightCounter(id, payload = {}) {
    return api.post(`/freight/available/${id}/accept-counter`, payload);
  },

  replyFreightBid(id, payload = {}) {
    return api.post(`/freight/available/${id}/reply-bid`, payload);
  },

  enterTransportQueue(id, payload = {}) {
    return api.post(`/freight/available/${id}/enter-queue`, payload);
  },

  leaveTransportQueue(id, payload = {}) {
    return api.post(`/freight/available/${id}/leave-queue`, payload);
  },

  /**
   * Hub unificado Fretes Disponíveis — GET /freight/carrier-hub
   * summary + items por tab + pagination
   */
  getCarrierHub(params = {}) {
    return api.get("/freight/carrier-hub", { params });
  },

  getCarrierHubById(id, idCarrier, idUser) {
    const params = {};
    if (idCarrier) params.idCarrier = idCarrier;
    if (idUser) params.idUser = idUser;
    return api.get(`/freight/carrier-hub/${id}`, {
      params: Object.keys(params).length ? params : undefined,
    });
  },

  acceptTransportQueue(id, payload = {}) {
    return api.post(`/freight/${id}/transport-queue/accept`, payload);
  },


  getStoppingPointStatusChanges(id) {
    return api.get(`/freight/v1/getStoppingPointStatusChanges/${id}`);
  },
};

export default freightApi2;
